import { endpoints } from '@/api/endpoints';
import type { RedirectUrls } from '@/api/paymentProvider/types';
import {
  directPaymentResponseSchema,
  directPaymentStatusResponseSchema,
  initiateDirectPaymentResponseSchema,
  selectAccountResponseSchema,
} from '@/api/SE/paymentProvider/schemas';
import type { InitiateDirectPaymentPayload } from '@/api/SE/paymentProvider/types';
import { apiRequest } from '@/api/utils/api';

export const selectAccount = async (payload: RedirectUrls) => {
  const result = await apiRequest({
    url: endpoints.paymentProvider.account,
    method: 'POST',
    data: payload,
    schema: selectAccountResponseSchema,
  });
  return result.response;
};

export const updateAccount = async (payload: RedirectUrls) => {
  const result = await apiRequest({
    url: endpoints.paymentProvider.account,
    method: 'PATCH',
    data: payload,
    schema: selectAccountResponseSchema,
  });
  return result.response;
};

export const getDirectPayment = (paymentId: string) =>
  apiRequest({
    url: endpoints.paymentProvider.directPayment.paymentId(paymentId).root,
    method: 'GET',
    schema: directPaymentResponseSchema,
  });

export const initiateDirectPayment = async (paymentId: string, payload: InitiateDirectPaymentPayload) => {
  const result = await apiRequest({
    url: endpoints.paymentProvider.directPayment.paymentId(paymentId).paymentRequest,
    method: 'POST',
    data: payload,
    schema: initiateDirectPaymentResponseSchema,
  });
  return result.paymentProviderToken;
};

export const getDirectPaymentStatus = (paymentId: string) =>
  apiRequest({
    url: endpoints.paymentProvider.directPayment.paymentId(paymentId).paymentRequest,
    method: 'GET',
    schema: directPaymentStatusResponseSchema,
  });

export const abortDirectPayment = (paymentId: string) =>
  apiRequest<''>({
    url: endpoints.paymentProvider.directPayment.paymentId(paymentId).root,
    method: 'DELETE',
  });
